import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { API_BASE_URL } from '../../../core/services/api.config';
import { AuditLogQuery, AuditLogResponse } from '../models/audit-log.models';

@Injectable({
  providedIn: 'root',
})
export class AuditLogService {
  private readonly http = inject(HttpClient);
  private readonly apiBaseUrl = inject(API_BASE_URL);

  getAuditLogs(query: AuditLogQuery): Observable<AuditLogResponse> {
    let params = new HttpParams();

    if (query.eventType) {
      params = params.set('eventType', query.eventType);
    }

    if (query.actorUserId) {
      params = params.set('actorUserId', String(query.actorUserId));
    }

    if (query.startDate) {
      params = params.set('startDate', query.startDate);
    }

    if (query.endDate) {
      params = params.set('endDate', query.endDate);
    }

    return this.http.get<AuditLogResponse>(`${this.apiBaseUrl}/audit-logs`, {
      params,
      withCredentials: true,
    });
  }
}
